import React, { Component } from 'react';
import { ErrorMessage, Form, Formik } from 'formik';
import CustomSelect from '../../../../common/formElements/CustomSelect';
import CustomSelectGroup from '../../../../common/formElements/CustomSelectGroup';
import { dynamicSort } from '../../../../common/utils/api_utils';
import {
  getTemplateCollectionFieldOptions,
  getProjectConstantOptions,
  getSessionOptions,
} from './EmailFieldsUtil';

export default class EmailTemplateForm extends Component {
  createSchemaForFields = () => {
    const {
      templateId,
      emailFields,
      sendToPropagate,
      emailCcFields,
      emailBccFields,
      getItemIdFrom,
      emailServicePlugin,
    } = this.props.emailTemplateRule;
    return {
      templateId: templateId || '',
      emailFields: emailFields || [],
      emailCcFields: emailCcFields || [],
      emailBccFields: emailBccFields || [],
      getItemIdFrom: getItemIdFrom
        ? getItemIdFrom
        : sendToPropagate
        ? 'sendToPropagate'
        : 'collectionUuid',
      emailServicePlugin: emailServicePlugin || '',
    };
  };

  getMailTemplateOptions = () => {
    let options = [{ value: '', label: '-Select One-' }];
    let templateOptions = this.props.mailTemplates
      .filter((item) => !item.parentTemplateId)
      .sort(dynamicSort('name'))
      .map((item, key) => ({ value: item.uuid, label: item.name }));
    return [...options, ...templateOptions];
  };

  getEmailServicePluginOptions = () => {
    const { installedPlugins } = this.props;
    let options = [{ value: '', label: 'DrapCode Default Email Provider' }];
    if (installedPlugins.some((plugin) => plugin.code === 'AWS_SES')) {
      options.push({ value: 'AWS_SES', label: 'AWS SES' });
    }
    if (installedPlugins.some((plugin) => plugin.code === 'SENDGRID')) {
      options.push({ value: 'SENDGRID', label: 'SendGrid' });
    }
    if (installedPlugins.some((plugin) => plugin.code === 'RESEND')) {
      options.push({ value: 'RESEND', label: 'Resend' });
    }
    return options;
  };

  getEmailFieldsOptions = (templateId) => {
    const { collections, mailTemplates, projectDetail } = this.props;
    const selectedTemplate = mailTemplates
      ? mailTemplates.find((e) => e.uuid === templateId)
      : null;
    const templateCollectionName = selectedTemplate ? selectedTemplate.collectionId : null;
    const templateCollection =
      collections && templateCollectionName
        ? collections.find((e) => e.collectionName === templateCollectionName)
        : null;
    let options = getTemplateCollectionFieldOptions(templateCollection, collections);
    let projectConstantOptions = getProjectConstantOptions(projectDetail);
    let sessionOptions = getSessionOptions(collections);
    let groupedOptions = [
      {
        label: 'Fields',
        options: options,
      },
      {
        label: 'Project Constant',
        options: projectConstantOptions,
      },
      {
        label: 'Current LoggedIn User',
        options: sessionOptions,
      },
    ];

    return groupedOptions;
  };
  itemIdOptions = [
    { value: 'collectionUuid', label: 'Item Id of Collection (Default)' },
    { value: 'previousResponse', label: 'Item Id from Previous Step' },
    { value: 'sendToPropagate', label: 'Send Propagated Collection (Required for Signup Form)' },
  ];
  handleSubmit = (values) => {
    this.props.handleSubmit(values);
  };

  closeAllOpenPopup = () => {
    this.props.closeAllOpenPopup();
  };

  render() {
    return (
      <Formik
        enableReinitialize={true}
        initialValues={this.createSchemaForFields()}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          this.handleSubmit(values);
          setSubmitting(false);
          resetForm();
        }}
      >
        {({ isSubmitting, values, setFieldValue, setFieldTouched, errors }) => (
          <Form>
            <div className="row">
              <div className="col-12">
                <div className="form-group">
                  <label>Email Template*</label>
                  <CustomSelect
                    name="templateId"
                    isMulti={false}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={this.getMailTemplateOptions()}
                    value={values['templateId']}
                  />
                  <ErrorMessage name="templateId">
                    {(msg) => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                  <small>Select a template you want to send via this event.</small>
                </div>
                <div className="form-group">
                  <label>Email Service Plugin*</label>
                  <CustomSelect
                    name="emailServicePlugin"
                    isMulti={false}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={this.getEmailServicePluginOptions()}
                    value={values['emailServicePlugin']}
                  />
                  <ErrorMessage name="emailServicePlugin">
                    {(msg) => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                  <small>Select the service from which you want to send the email.</small>
                </div>
                <div className="form-group">
                  <label>Email Address Fields*</label>
                  <CustomSelectGroup
                    name="emailFields"
                    isMulti={true}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={this.getEmailFieldsOptions(values['templateId'])}
                    value={values['emailFields']}
                  />
                  <ErrorMessage name="emailFields">
                    {(msg) => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                  <small>Select the email address field.</small>
                </div>
                <div className="form-group">
                  <label>Email Address (CC) Fields*</label>
                  <CustomSelectGroup
                    name="emailCcFields"
                    isMulti={true}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={this.getEmailFieldsOptions(values['templateId'])}
                    value={values['emailCcFields']}
                  />
                  <ErrorMessage name="emailCcFields">
                    {(msg) => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                  <small>Select the email address (CC) field.</small>
                </div>
                <div className="form-group">
                  <label>Email Address (BCC) Fields*</label>
                  <CustomSelectGroup
                    name="emailBccFields"
                    isMulti={true}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={this.getEmailFieldsOptions(values['templateId'])}
                    value={values['emailBccFields']}
                  />
                  <ErrorMessage name="emailBccFields">
                    {(msg) => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                  <small>Select the email address (BCC) field.</small>
                </div>
                <div className="form-group">
                  <label>Get Item Id From</label>
                  <CustomSelect
                    name="getItemIdFrom"
                    isMulti={false}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={this.itemIdOptions}
                    value={values['getItemIdFrom']}
                    onChangeValue={(name, value) => setFieldValue('getItemIdFrom', value)}
                  />
                </div>
              </div>
            </div>
            {this.props.children}
          </Form>
        )}
      </Formik>
    );
  }
}
